import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CircleIcon from '@mui/icons-material/Circle';
import ErrorIcon from '@mui/icons-material/Error';
import { InputAdornment, TextField, TextFieldProps } from '@mui/material';
import React from 'react';
import { makeStyles } from 'tss-react/mui';

interface SearchFieldProps extends Omit<TextFieldProps, 'onChange' | 'value'> {
  value?: string;

  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const PaiAlertTextField: React.FC<SearchFieldProps> = ({ value, onChange, ...props }) => {
  const { classes, cx } = useStyles({ valid: !!value && !props.error });

  return (
    <TextField
      {...props}
      className={classes.textfield}
      value={value}
      onChange={onChange}
      variant={'outlined'}
      size={'small'}
      InputProps={{
        classes: { input: classes.input },
        startAdornment: (
          <InputAdornment position={'start'}>
            {!value ? (
              <CircleIcon className={cx(classes.icon, 'error')} />
            ) : !props.error ? (
              <CheckCircleIcon className={cx(classes.icon, 'check')} />
            ) : (
              <ErrorIcon className={cx(classes.icon, 'error')} />
            )}
          </InputAdornment>
        ),
      }}
    />
  );
};

const useStyles = makeStyles<{ valid: boolean }>()((theme, { valid }) => ({
  textfield: {
    background: '#FFF',
    borderRadius: '16px',
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
    '& .MuiInputBase-root': {
      border: !valid ? `1px solid ${theme.palette.greys.light}` : `1px solid ${theme.palette.primary.main}`,
      borderRadius: '16px',
      '&.Mui-error': {
        border: `1px solid ${theme.palette.error.main}`,
      },
    },
  },
  input: {
    fontSize: theme.typography.pxToRem(15),
    padding: '4px 12px',
    borderTopLeftRadius: '16px',
    borderBottomLeftRadius: '16px',
    height: 'calc(30px - 8px)',
    '& .Mui-disabled': {
      color: theme.palette.greys.light,
    },
    '&::placeholder': {
      opacity: 0.5,
      fontSize: theme.typography.pxToRem(15),
    },
    '&:focus': {
      '&::placeholder': {
        opacity: 0,
      },
    },
  },
  icon: {
    fontSize: theme.typography.pxToRem(28),
    margin: '-12px',
    '&.check': {
      color: theme.palette.primary.main,
    },
    '&.error': {
      color: theme.palette.error.main,
    },
  },
}));

export default PaiAlertTextField;
